import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  tableContainerOverride: {
    "& td:last-child, & th:last-child": {
      position: "unset !important",
    },
  },
  cell: {
    display: "flex",
    flexDirection: "column",
    fontSize: 15,
  },
  disabledCell: {
    display: "flex",
    flexDirection: "column",
    color: theme.color.gray3,
    fontSize: 15,
  },
  proofOfDeliveryButton: {
    color: "#000000 !important",
    fontWeight: "normal",
    padding: "4px 8px",
    minWidth: "auto",
    textTransform: "none",
    backgroundColor: "transparent",
    border: "none",
    boxShadow: "none",
    outline: "none",
    transition: "none",
    animation: "none",
    "&.MuiButton-text": {
      color: "#000000 !important",
      fontWeight: "normal",
      border: "none",
    },
    "&:hover": {
      backgroundColor: "#e0e0e0 !important",
      color: "#000000 !important",
      fontWeight: "normal",
      boxShadow: "none",
      border: "none",
      transition: "none",
      animation: "none",
    },
    "&:focus": {
      color: "#000000 !important",
      fontWeight: "normal",
      boxShadow: "none",
      border: "none",
      outline: "none",
    },
    "&:active": {
      color: "#000000 !important",
      fontWeight: "normal",
      boxShadow: "none",
      border: "none",
    },
  },
  badge: {
    width: 124,
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    display: "inline-block",
    overflow: "hidden",
    fontFamily: "Roboto",
    fontSize: 13,
    textAlign: "center",
    fontWeight: 500,
  },
}));
